// Capacitor
import { Capacitor } from '@capacitor/core'
import { App as CapacitorApp } from '@capacitor/app'

// Stores
import { useGeolocationStore } from '@/stores/index.js'

/**
 * Refresca la politica de ubicacion ficticia cuando la app vuelve del fondo.
 *
 * El toggle del admin es el kill switch de la politica por organizacion, pero sin esto solo llegaba
 * al dispositivo en un arranque en frio o en un login. Ante un falso positivo en campo eso obliga a
 * explicarle al usuario como matar la app —que en Android no es volver al home—; con el resume basta
 * con que la mande al fondo y la retome.
 *
 * El listener se registra una sola vez y lee la organizacion vigente de una variable de modulo, para
 * que un re-login con otro usuario no quede refrescando la politica de la organizacion anterior.
 */
let registered = false
let watchedOrgId = null

export function watchMockPolicyOnResume (orgId) {
  watchedOrgId = orgId

  if (!Capacitor.isNativePlatform() || registered) return

  // La bandera se levanta ANTES de registrar: addListener devuelve una promesa y guardarla como
  // marca dejaria una ventana en la que dos llamadas seguidas registran dos listeners.
  registered = true

  CapacitorApp.addListener('appStateChange', ({ isActive }) => {
    if (!isActive || watchedOrgId == null) return

    useGeolocationStore()
      .refreshMockPolicy(watchedOrgId)
      .catch(() => { /* best-effort: conserva la politica vigente */ })
  })
}

/** El logout deja de vigilar: sin organizacion no hay politica que refrescar. */
export function unwatchMockPolicyOnResume () {
  watchedOrgId = null
}
